export default __webpack_public_path__ + "static/media/gallery - story - three brothers (1)_03.9ef91cad.jpg";